import React from "react";
import SectionHeading from "./Section-Heading";
import SectionBlooming from "./Section-Blooming";
import SectionPast from "./Section-Past";
import SectionLight from "./Section-Light";
import SectionPixel from "./Section-Pixel";
import SectionPetals from "./Section-Petals";
import { Wrapper } from "../styles/components/Global/Global";

const Landing = () => {
  return (
    <Wrapper>
      <SectionHeading />
      <SectionBlooming />
      <SectionPast />
      <SectionLight />
      <SectionPixel />
      <SectionPetals />
    </Wrapper>
  );
};

export default Landing;
